<div class="billing-card">
  <div class="d-flex flex-wrap mb-4 pb-0 rounded">
    <span class="vertical_line"></span>
    <h1 class="fs-3 text-dark fw-boldest ms-2">
      Billing Information
    </h1>
  </div>
    
  <form [formGroup]="billingForm">
    <div class="form-grid">
      <!-- Full Name  col-span-2-->
      <div class="form-field ">
        <label class="form-label">Full Name<span class="required"></span></label>
        <input formControlName="fullName" type="text" class="form-input" placeholder="Enter name"
               [ngClass]="{ 'error-input': f['fullName'].touched && f['fullName'].invalid }" />
        <div class="error-text" *ngIf="f['fullName'].touched && f['fullName'].invalid">Full Name is required.</div>
      </div>

      <!-- Email -->
      <div class="form-field ">
        <label class="form-label">Email<span class="required"></span></label>
        <input formControlName="email" type="email" class="form-input" placeholder="Enter email"
               [ngClass]="{ 'error-input': f['email'].touched && f['email'].invalid }" />
        <div class="error-text" *ngIf="f['email'].touched && f['email'].invalid">Email is required.</div>
      </div>

      <!-- Phone -->
      <div class="form-field ">
        <label class="form-label">Phone<span class="required"></span></label>
        <input formControlName="phone" type="text" class="form-input" placeholder="Enter phone number"
          [ngClass]="{ 'error-input': f['phone'].touched && f['phone'].invalid }" />
        <div class="error-text" *ngIf="f['phone'].touched && f['phone'].invalid">Phone is required.</div>
     </div>

      <div class="form-field">
        <label class="form-label">GST Number(Optional)</label>
        <input formControlName="customerGST" type="text" class="form-input" placeholder="Enter GST number" />
     </div>
    
<!-- Address -->
<div class="form-field col-span-2">
  <label class="form-label fw-bold" for="address">Address</label>
  <textarea id="address" formControlName="address" rows="3" class="form-input" placeholder="Enter address"
    [ngClass]="{ 'error-input': f['address'].touched && f['address'].invalid }"></textarea>
  <!-- <div class="error-text" *ngIf="f['address'].touched && f['address'].invalid">
    Address is required.
  </div> -->
</div>

<!-- Country -->
<div class="form-field">
      <label for="country" class="form-label fw-bold">Country<span class="text-danger">*</span></label>
      <ng-select [items]="countries" formControlName="country" bindLabel="name" bindValue="id" 
        [searchable]="true" [clearable]="false" placeholder="Choose a country" id="country" [ngClass]="{
          'error-input': f['country'].touched && f['country'].invalid,
          'valid-input': f['country'].touched && f['country'].valid
        }"></ng-select>
      <div class="error-text" *ngIf="f['country'].hasError('required') && (f['country'].touched || f['country'].dirty)">
        Country is required.
      </div>
    </div>
    
    <!-- State -->
    <div class="form-field">
      <label for="state" class="form-label fw-bold">State<span class="text-danger" *ngIf="states.length">*</span></label>
      <ng-select [items]="states" formControlName="state" bindLabel="name" bindValue="id" 
        [searchable]="true" [clearable]="false" placeholder="Choose a state" id="state" [ngClass]="{
          'error-input': f['state'].touched && f['state'].invalid,
          'valid-input': f['state'].touched && f['state'].valid
        }"></ng-select>
      <div class="error-text" *ngIf="f['state'].hasError('required') && (f['state'].touched || f['state'].dirty)">
        State is required.
      </div>
    </div>
    
    <!-- City -->
    <div class="form-field">
      <label for="city" class="form-label fw-bold">City<span class="text-danger" *ngIf="cities.length">*</span></label>
      <ng-select [items]="cities" formControlName="city" bindLabel="name" bindValue="id" 
        [searchable]="true" [clearable]="false" placeholder="Choose a city" id="city" [ngClass]="{
          'error-input': f['city'].touched && f['city'].invalid,
          'valid-input': f['city'].touched && f['city'].valid
        }"></ng-select>
      <div class="error-text" *ngIf="f['city'].hasError('required') && (f['city'].touched || f['city'].dirty)">
        City is required.
      </div>
    </div>
    
    
    <!-- Pincode -->
    <div class="form-field">
      <label class="form-label">Pincode<span class="text-danger">*</span></label>
      <input formControlName="pincode" type="text" class="form-input" placeholder="Enter pincode" maxlength="10"
        [ngClass]="{ 'error-input': f['pincode'].touched && f['pincode'].invalid }" />
      <div class="error-text" *ngIf="f['pincode'].touched && f['pincode'].errors?.['required']">Pincode is required.</div>
      <div class="error-text" *ngIf="f['pincode'].touched && f['pincode'].errors?.['minlength']">Pincode must be at least 3 characters.</div>
      <div class="error-text" *ngIf="f['pincode'].touched && f['pincode'].errors?.['maxlength']">Pincode must not exceed 10 characters.</div>
      <div class="error-text" *ngIf="f['pincode'].touched && f['pincode'].errors?.['pattern']">Pincode must be alphanumeric.</div>
    </div>
    </div>
    
    </form>
    </div>